import { render, staticRenderFns } from "./ModalEditStudentMailAddress.vue?vue&type=template&id=487652cb&scoped=true&lang=pug&"
import script from "./ModalEditStudentMailAddress.vue?vue&type=script&lang=ts&"
export * from "./ModalEditStudentMailAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487652cb",
  null
  
)

export default component.exports